/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetEquipmentDetailsRequest = {
  /**
   * The id of the device to get the equipment details view for
   */
  deviceId: string;
  agentId: string;
};

/** @internal */
export type GetEquipmentDetailsRequest$Outbound = {
  device_id: string;
  agent_id: string;
};

/** @internal */
export const GetEquipmentDetailsRequest$outboundSchema: z.ZodType<
  GetEquipmentDetailsRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentDetailsRequest
> = z.object({
  deviceId: z.string(),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    deviceId: "device_id",
    agentId: "agent_id",
  });
});

export function getEquipmentDetailsRequestToJSON(
  getEquipmentDetailsRequest: GetEquipmentDetailsRequest,
): string {
  return JSON.stringify(
    GetEquipmentDetailsRequest$outboundSchema.parse(getEquipmentDetailsRequest),
  );
}
